import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind class merger — same shape as the shadcn helper used in chanl-site.
 * Combines clsx (conditional classes) with tailwind-merge (deduping conflicting
 * Tailwind utilities so the last one wins).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Format a duration in seconds as MM:SS.
 * Copied from `chanl-platform/packages/audial-widget/src/lib/utils.ts`.
 */
export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}
